<template>
  <div v-if="!isGuest" class="header-logo-wrapper col-auto p-0">      
    <!-- <div class="logo-wrapper">
      <router-link to="/">
        <img class="img-fluid-custom" src="../../assets/images/logo/logo-pln-dashboard.svg" alt />
      </router-link>
    </div> -->
    <div class="toggle-sidebar" @click="toggle_sidebar">
      <vue-feather
        class="status_toggle middle sidebar-toggle"
        type="align-justify"
        id="sidebar-toggle"
      ></vue-feather>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { checkIsGuest } from "@/utils/helper";

export default {
  name: "Logo",
  mounted() {
    this.$store.dispatch("menu/opensidebar");
    this.$store.state.menu.activeoverlay = true;
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
    }),
    isGuest() {
      return checkIsGuest();
    }
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch("menu/opensidebar");
      this.$store.state.menu.activeoverlay = false;
    },
  },
};
</script>
